import Vue from 'vue';
import App from './App.vue';

Vue.config.productionTip = false;

const target = document.querySelector('#interactive-hero-app');

const props = {
  headerImageUrl: target.dataset.headerImageUrl,
  skiplinkTargetElement: target.dataset.skiplinkTargetElement,
  apiEndpoint: target.dataset.apiEndpoint,
};

new Vue({
  render: h => h(App, { props }),
}).$mount('#interactive-hero-app')
